import * as React from "react";
import i18n from "i18n";
import { TypeCell, NodeCell, ThroughputCell } from "components/inputs/InputsOveriew";
import FailuresCell from "components/inputs/InputsOveriew/cells/FailuresCell";
import MessageCountCell from "components/inputs/InputsOveriew/cells/MessageCountCell";
import ExtractorCountCell from "components/inputs/InputsOveriew/cells/ExtractorCountCell";
import AssociatedStreamsCell from "components/inputs/InputsOveriew/cells/AssociatedStreamsCell";
import { METRIC_COLUMN_IDS } from "components/inputs/InputsOveriew/metricColumns";
import { InputStateBadge } from "components/inputs";
import Routes from "routing/Routes";
import { Link } from "components/common";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
const customColumnRenderers = ({ inputTypes, inputStates }) => ({
  attributes: {
    title: {
      renderCell: (_title, input) => /* @__PURE__ */ React.createElement(
        Link,
        {
          to: Routes.SYSTEM.INPUT_DIAGNOSIS(input.id),
          title: i18n.t("overview.show_diagnosis_for", { ns: "inputs", title: input.title })
        },
        input.title
      )
    },
    type: {
      renderCell: (type) => /* @__PURE__ */ React.createElement(TypeCell, { type, inputTypes })
    },
    desired_state: {
      renderCell: (_state, input) => /* @__PURE__ */ React.createElement(InputStateBadge, { input, inputStates }),
      staticWidth: 130
    },
    node_id: {
      renderCell: (_type, input) => /* @__PURE__ */ React.createElement(NodeCell, { input }),
      staticWidth: COLUMN_WIDTH.reference
    },
    traffic: {
      renderCell: (_traffic, input) => /* @__PURE__ */ React.createElement(ThroughputCell, { input }),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    input_failures: {
      renderCell: (_failures, input) => /* @__PURE__ */ React.createElement(FailuresCell, { input }),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    address: {
      renderCell: (_address, input) => {
        var _a;
        return ((_a = input.attributes) == null ? void 0 : _a.bind_address) || i18n.t("overview.not_available", { ns: "inputs" });
      },
      staticWidth: 125
    },
    port: {
      renderCell: (_port, input) => {
        var _a;
        return ((_a = input.attributes) == null ? void 0 : _a.port) || i18n.t("overview.not_available", { ns: "inputs" });
      },
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    [METRIC_COLUMN_IDS.messagesPerStream]: {
      renderCell: (_value, input) => /* @__PURE__ */ React.createElement(MessageCountCell, { input }),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    [METRIC_COLUMN_IDS.extractorCount]: {
      renderCell: (_value, input) => /* @__PURE__ */ React.createElement(ExtractorCountCell, { input }),
      staticWidth: "matchHeader"
    },
    [METRIC_COLUMN_IDS.associatedStreams]: {
      renderCell: (_value, input) => /* @__PURE__ */ React.createElement(AssociatedStreamsCell, { input }),
      staticWidth: "matchHeader",
      textAlign: "right"
    }
  }
});
export default customColumnRenderers;
